
import { computed, defineComponent, ref } from 'vue'
import type { PropType } from 'vue'
import AsahiArrow from '@/components/library/assets/AsahiArrow.vue'
import AsahiRadioButton from '@/components/library/AsahiRadioButton.vue'

interface Option {
  value: string | number
  label: string
  disabled?: boolean
  icon?: string
}

export default defineComponent({
  name: 'AsahiSelectBox',
  components: { AsahiRadioButton, AsahiArrow },
  props: {
    modelValue: {
      required: true
    },
    options: {
      type: Array as PropType<Option[]>,
      required: true
    },
    optionsWrap: {
      type: Boolean,
      required: false
    },
    label: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    defaultLabel: {
      type: String,
      default: 'Select an option'
    },
    isValid: {
      type: Boolean,
      default: true
    },
    isTicket: {
      type: Boolean,
      default: true
    },
    fullWidth: {
      type: Boolean,
      default: false
    },
    hFillOption: {
      type: Boolean,
      default: false
    },
    noBorder: {
      type: Boolean,
      default: false
    },
    color: {
      type: String,
      default: ''
    },
    isInModal: {
      type: Boolean,
      default: false
    },
    isUserListing: {
      type: Boolean,
      default: false
    },
    secondLine: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup (props, { emit }) {
    const openDropdown = ref(false)

    const toggleDropdown = () => {
      openDropdown.value = !openDropdown.value
    }

    const selectOption = (option: Option) => {
      if (!option.disabled) {
        emit('update:modelValue', option.value)
        openDropdown.value = false
      }
    }

    const selectedOption = computed(() => {
      if (Array.isArray(props.options)) {
        return props.options.find(option => option.value === props.modelValue)
      }
      return undefined
    })

    const selectedLabel = computed(() => {
      return selectedOption.value?.label || ''
    })

    const displayLabel = computed(() => {
      return selectedLabel.value
    })

    const selectedOptionIcon = computed(() => {
      return selectedOption.value?.icon
    })

    const fixedIcon = computed(() => {
      return selectedLabel.value === 'Select Status' ? require('@/components/library/assets/BlackAlarm.svg') : require('@/components/library/assets/icons.svg')
    })

    const filteredOptions = computed(() => {
      return props.options.filter(option => (option.label !== 'Ticket Status') && (option.label !== 'Select ShipTo'))
    })

    return {
      openDropdown,
      toggleDropdown,
      selectOption,
      selectedLabel,
      displayLabel,
      selectedOptionIcon,
      selectedOption,
      fixedIcon,
      filteredOptions
    }
  },
  methods: {
    handleClickOutside () {
      this.openDropdown = false
    }
  }
})
